import * as UIUtil from "/app/js/util/UI.js";
import { getNotice } from "../api/NoticeApi.js";
import * as _Notice from "./Notice.js";

export const open = async function (noticeId, pushHistory = true) {
    try {
        // 히스토리에 상태 추가 (뒤로가기 지원)
        if (pushHistory) {
            const currentState = history.state;

            // 현재 상태가 Notice 메뉴이거나 다른 noticeId인 경우에만 히스토리 추가
            if (!currentState?.noticeId || currentState.noticeId !== noticeId) {
                history.pushState({ menuKey: 'Notice', noticeId }, '', `#Notice/${noticeId}`);
            }
        }

        const lang = document.documentElement.lang || 'ko';
        const htmlUrl = `app/html/${lang}/prcenter/공지사항-상세보기.html`;

        document.querySelector(".banner")?.remove();
        document.querySelector("section.contents-wrap")?.remove();

        const response = await fetch(htmlUrl);
        const html = await response.text();

        const wrapper = document.createElement("div");
        wrapper.innerHTML = html;

        const bannerEl = wrapper.querySelector(".banner");
        const contentEl = wrapper.querySelector("section.contents-wrap");

        const headerWrap = document.querySelector(".headerWrap");

        if (bannerEl) headerWrap.insertAdjacentElement("afterend", bannerEl);
        if (contentEl) bannerEl.insertAdjacentElement("afterend", contentEl);

        const result = await getNotice(noticeId);
        if (!result.SUCCESS) {
            UIUtil.msgBox("공지사항 조회 실패", "error");
            return;
        }

        renderNotice(result.RESULT);
        drawPrevNextLinks(result.RESULT);
        initEvent();

    } catch (error) {
        console.error(error);
    }
};
window.NoticeDetail_open = open;

const renderNotice = function (data) {
    const categoryEl = document.querySelector(".board-view .tit-cnt span");
    const titleEl = document.querySelector(".board-view .tit-cnt h2");
    const dateEl = document.querySelector(".board-view .tit-cnt p");
    const contentDiv = document.querySelector(".board-view .txt-cnt");
    const imgContainer = document.querySelector(".board-view .img-cnt");

    if (categoryEl) categoryEl.textContent = data.category ?? "기타";
    if (titleEl) titleEl.textContent = data.title ?? "";
    if (dateEl) dateEl.textContent = data.registerDate ?? "";

    if (imgContainer && Array.isArray(data.noticeFiles)) {
        imgContainer.innerHTML = "";

        data.noticeFiles.forEach(file => {
            const img = document.createElement("img");
            img.src = `/notice/file/view/${file.noticeImgId}`;
            img.alt = file.fileName || "";
            img.style.width = "100%";
            img.style.height = "auto";
            img.style.marginBottom = "20px";
            imgContainer.appendChild(img);
        });
    }

    if (data.category === "Geotwo News" && contentDiv) {
        contentDiv.style.display = "block";
        contentDiv.innerHTML = data.content ?? "";
    } else {
        if (contentDiv) {
            contentDiv.style.display = "none";
            contentDiv.innerHTML = "";
        }
    }
};

const drawPrevNextLinks = function (data) {
    const prevNextEl = document.querySelector(".view-select-cnt");
    if (!prevNextEl) return;

    const prevEl = prevNextEl.querySelector(".prev");
    const nextEl = prevNextEl.querySelector(".next");

    addPrevNextLink(prevEl, data.previousId, data.previousTitle, 'prev');
    addPrevNextLink(nextEl, data.nextId, data.nextTitle, 'next');
};

const addPrevNextLink = function (containerEl, id, title, direction) {
    containerEl.innerHTML = ""; // 이전 내용 전체 제거
    containerEl.innerHTML = createPrevNextA(id, title, direction);

    if (id) {
        containerEl.querySelector("a")?.addEventListener("click", (e) => {
            e.preventDefault();
            open(id, true); // 상세 재호출 시 히스토리 추가
        });
    }
};

const createPrevNextA = function (id, title, direction) {
    const iconClass = direction === "prev" ? "i-prev" : "i-next";
    const lang = document.documentElement.lang || "ko";

    const label = direction === "prev"
        ? (lang === "en" ? "Previous" : "이전글")
        : (lang === "en" ? "Next" : "다음글");

    return `
        <a ${id ? `id="${id}" href="#"` : `href="javascript:void(0)"`}>
            <span>${label}<i class="${iconClass}"></i></span>
            <p>${title}</p>
        </a>
    `;
};
const initEvent = function () {
    const backBtn = document.querySelector(".btn-wrap .btn-large");

    backBtn.addEventListener("click", function (e) {
        e.preventDefault();
        // 브라우저 히스토리를 사용하여 뒤로가기
        history.back();
    });
};
